/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Link, Modal, ModalBody, ModalHeader, Typography } from '@one-thd/sui-atomic-components';
import { useDrawer } from '../../DrawerProvider';

export const LegalComplianceMessage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { drawerState } = useDrawer();

  useEffect(() => {
    if (drawerState === 'MINIMIZED' && isOpen) {
      setIsOpen(false);
    }
  }, [drawerState, isOpen]);

  return (
    <div className="sui-pb-2 sui-pb-6">
      <Typography color="subtle" align="center">
        AI-generated responses.&nbsp;
        <Typography
          component="span"
          decoration="underline"
          color="subtle"
          tabIndex="0"
          role="button"
          onClick={() => setIsOpen(true)}
        >
          More information
        </Typography>
      </Typography>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        size="sm"
        data-testid="legal-compliance-modal"
      >
        <ModalHeader onClose={() => setIsOpen(false)}>More Information</ModalHeader>
        <ModalBody>
          <Typography weight="regular" variant="body-xs">
            {`Magic Apron provides AI-generated responses from manufacturer documentation and Q&A, customer reviews (which are not screened for accuracy), and information from the internet.
          For additional information about our products or services, please review the manufacturer’s documentation or contact The Home Depot customer service.
          For other queries, please verify responses. Magic Apron is a shopping assistant for questions about our products and services; do not rely on Magic Apron for professional, medical, legal, or financial advice.
          Magic Apron may not respond to certain questions. For your protection, do not share sensitive personal information. We collect and use personal information in accordance with our
          `}<Link href="https://www.homedepot.com/privacy/privacy-and-security-statement" variant="body-xs" target="_parent">Privacy & Security Statement</Link>.
          </Typography>
          <Typography weight="regular" variant="body-xs">
            {`Some states require licenses before home improvement services may be legally performed.
          For example, in Massachusetts, you must be licensed by its Division of Professional Licensure to legally perform plumbing work.
          Please check with the laws in your state.`}
          </Typography>
        </ModalBody>
      </Modal>
    </div>
  );
};
